var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:{'active':_vm.isActive},attrs:{"title":_vm.tooltip},on:{"click":function($event){return _vm.setMenuState()}}},[_c('i',{class:_vm.iconClass})])}
var staticRenderFns = []

export { render, staticRenderFns }